import Cookies from "js-cookie";
import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";
import router from "@/router";
import { AUTHENTICATION__API } from "@/_helpers/urls";
import { AUTHENTICATION__MUTATIONS } from "../mutation-types";
import { AUTHENTICATION__ACTIONS } from "../action-types";
import { startTrackingInactivity } from "@/utils/inactivityTracker";

// State
const state = {
  token: null,
  el: 1,
  step: 1,
  loginInfo: {
    email: "",
    password: "",
    isApiLogin: "0",
  },
  resetInfo: {
    code: null,
    isReset: false,
    attempt: 0,
    new_password: "",
    confirm_password: "",
  },
  registerInfo: {
    owner_type: null,
    fname: "",
    lname: "",
    email: "",
    password: "",
    confirmPassword: "",
    otp: "",
    receivedOTP: "",
  },
  viewPassword: false,
  ib_status: localStorage.getItem('ib_status') ?
    parseInt(localStorage.getItem('ib_status')) : 0,
  logOutTime: 0,

   twoFaLogin: {
    required: false,
    two_fa_token: null,
  },
};

//Getters
const getters = {
  validToLogin(state) {
    return state.loginInfo.email && state.loginInfo.password;
  },
  validToRegister(state) {
    return (
      state.registerInfo.owner_type &&
      state.registerInfo.fname &&
      state.registerInfo.email &&
      state.registerInfo.password &&
      state.registerInfo.password.length >= 8 &&
      state.registerInfo.password === state.registerInfo.confirmPassword
    );
  },

  validToReset(state) {
    return !!state.resetInfo.email;
  },
};

//Mutations
const mutations = {
  [AUTHENTICATION__MUTATIONS.REGISTER_ACCOUNT_TYPE](state, type) {
    if (type === "Individual") {
      state.registerInfo.owner_type = 1;
    } else if (type === "Company") {
      state.registerInfo.owner_type = 2;
    }
  },
  [AUTHENTICATION__MUTATIONS.LOGIN_EMAIL](state, value) {
    state.loginInfo.email = value;
  },
  [AUTHENTICATION__MUTATIONS.UPDATESTEPPER](state, value) {
    state.el = value;
  },
  [AUTHENTICATION__MUTATIONS.LOGIN_PASSWORD](state, value) {
    state.loginInfo.password = value;
  },
  [AUTHENTICATION__MUTATIONS.RESET_NEWPASS](state, value) {
    // console.log(value)
    state.resetInfo.new_password = value;
  },
  [AUTHENTICATION__MUTATIONS.RESET_REPEATPASS](state, value) {
    // console.log(value)
    state.resetInfo.confirm_password = value;
  },
  [AUTHENTICATION__MUTATIONS.RESET_ATTEMPT](state, attempt) {
    state.resetInfo.attempt = attempt;
  },
  [AUTHENTICATION__MUTATIONS.RESET_CODE](state, code) {
    state.resetInfo.code = code;
  },
  [AUTHENTICATION__MUTATIONS.CREATEDTIME](state, time) {
    const twoMinutes = 2 * 60 * 1000;
    Cookies.set("verification-time", time, { expires: twoMinutes });
  },
  [AUTHENTICATION__MUTATIONS.SEND_EMAIL_TO](state, sendEmailTo) {
    state.resetInfo.sendEmailTo = sendEmailTo;
  },
  [AUTHENTICATION__MUTATIONS.TOKEN](state, data) {
    state.token = data.client.token;
    state.logOutTime = data.logOutTime;
    state.ib_status = data.ib_status;
    localStorage.setItem('ib_status', data.ib_status);
  },
  [AUTHENTICATION__MUTATIONS.REMOVE_TOKEN](state) {
    state.token = null;
    state.ib_status = 0;
  },
  [AUTHENTICATION__MUTATIONS.REGISTER_FNAME](state, value) {
    state.registerInfo.fname = value;
  },
  [AUTHENTICATION__MUTATIONS.REGISTER_LNAME](state, value) {
    state.registerInfo.lname = value;
  },
  [AUTHENTICATION__MUTATIONS.REGISTER_EMAIL](state, value) {
    state.registerInfo.email = value;
  },
  [AUTHENTICATION__MUTATIONS.REGISTER_PASSWORD](state, value) {
    state.registerInfo.password = value;
  },
  [AUTHENTICATION__MUTATIONS.REGISTER_CONFIRM_PASSWORD](state, value) {
    state.registerInfo.confirmPassword = value;
  },
  [AUTHENTICATION__MUTATIONS.REGISTER_OTP](state, value) {
    state.registerInfo.otp = value;
  },
  [AUTHENTICATION__MUTATIONS.USER_OTP](state, value) {
    state.registerInfo.receivedOTP = value;
  },
  [AUTHENTICATION__MUTATIONS.RESET_REGISTER_INFO](state) {
    state.registerInfo.owner_type = "";
    state.registerInfo.fname = "";
    state.registerInfo.lname = "";
    state.registerInfo.email = "";
    state.registerInfo.password = "";
    state.registerInfo.confirmPassword = "";
    state.registerInfo.receivedOTP = "";
  },
  [AUTHENTICATION__MUTATIONS.RESET_LOGIN_INFO](state) {
    state.loginInfo.email = "";
    state.loginInfo.password = "";
    state.loginInfo.isApiLogin = "0";
  },
  [AUTHENTICATION__MUTATIONS.VIEW_PASSWORD](state) {
    state.viewPassword = !state.viewPassword;
  },
  [AUTHENTICATION__MUTATIONS.CHANGESTEP](state, value) {
    state.step = value;
  },
  [AUTHENTICATION__MUTATIONS.RESET_RECEIVED_OTP](state) {
    state.registerInfo.receivedOTP = "";
  },
  
  SET_TWOFA_LOGIN(state, payload) {
    state.twoFaLogin.required = true;
    state.twoFaLogin.two_fa_token = payload?.two_fa_token || null;
  },

  CLEAR_TWOFA_LOGIN(state) {
    state.twoFaLogin.required = false;
    state.twoFaLogin.two_fa_token = null;
  },
};
// Actions
const actions = {
  async [AUTHENTICATION__ACTIONS.SENDREGISTEROTP]({ commit, state }) {
    try {
      const { owner_type, fname, lname, email, password, confirmPassword } =
        state.registerInfo;

      if (
        owner_type !== null &&
        fname !== "" &&
        lname !== "" &&
        email !== "" &&
        password !== "" &&
        confirmPassword !== ""
      ) {
        const res = await HTTP().post(AUTHENTICATION__API.SENDREGISTEROTP, {
          email: state.registerInfo.email,
        });

        if (res.status === 200) {
          router.push("/send-otp");
          toast.success(`OTP has sent to ${email}`);
        }
      } else {
        toast.error("Please fill in all the required fields");
        router.push("/create-account");
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [AUTHENTICATION__ACTIONS.REGISTER]({ commit, state }) {
    try {
      const requestData = {
        fname: state.registerInfo.fname,
        lname: state.registerInfo.lname,
        email: state.registerInfo.email,
        password: state.registerInfo.password,
        owner_type: state.registerInfo.owner_type,
        otp: state.registerInfo.receivedOTP,
      };

      if (
        requestData.fname === null ||
        requestData.lname === null ||
        requestData.email === null ||
        requestData.password === null ||
        requestData.owner_type === null
      ) {
        toast.error("Please fill all the fields");
        router.push("/create-account");
        return;
      }

      const { data } = await HTTP().post(
        AUTHENTICATION__API.AUTHREGISTER,
        requestData
      );

      if (data.type === "success") {
        toast.success(data.message);
        router.push("/");
      } else {
        toast.error(data.message);
        state.registerInfo.receivedOTP = "";
      }
    } catch (error) {
      toast.error(error.response.data.message);
      state.registerInfo.receivedOTP = "";
    }
  },

  // async [AUTHENTICATION__ACTIONS.LOGIN]({ commit, state }) {
  //   try {
  //     const response = await HTTP().post(AUTHENTICATION__API.AUTHLOGIN, {
  //       email: state.loginInfo.email,
  //       password: state.loginInfo.password,
  //       isApiLogin: state.loginInfo.isApiLogin,
  //     });

  //     const { data } = response;

  //     if (response.status === 200) {
  //       commit(AUTHENTICATION__MUTATIONS.TOKEN, data);
  //       commit(AUTHENTICATION__MUTATIONS.RESET_LOGIN_INFO);
  //       toast.success(data.message);
  //       state.el = 1;
  //       router.push("/dashboard");
  //       if (state.logOutTime > 0) {
  //         startTrackingInactivity(this);
  //       }
  //       return;
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     toast.error(error.response.data.message);
  //   }
  // },

   async [AUTHENTICATION__ACTIONS.LOGIN]({ commit, state }) {
  try {
    const response = await HTTP().post(AUTHENTICATION__API.AUTHLOGIN, {
      email: state.loginInfo.email,
      password: state.loginInfo.password,
      isApiLogin: state.loginInfo.isApiLogin,
    });

    const { data } = response;

    if (response.status === 200) {
      // Broker feature flag (default: enabled to keep old behavior intact)
      const is2faFeatureEnabled = Number(data?.client_2fa_enabled ?? 1) === 1;

      // Only require OTP if broker feature is enabled
      if (is2faFeatureEnabled && data?.two_fa_required === true) {
        if (!data?.two_fa_token) {
          toast.error("2FA token missing from server");
          return;
        }

        commit("SET_TWOFA_LOGIN", { two_fa_token: data.two_fa_token });
        toast.success(data.message || "OTP required");
        return data; // component will open modal
      }

      // If feature disabled OR OTP not required -> normal login
      commit(AUTHENTICATION__MUTATIONS.TOKEN, data);
      commit(AUTHENTICATION__MUTATIONS.RESET_LOGIN_INFO);
      toast.success(data.message || "Login successful");
      router.push("/dashboard");
      return data;
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Login failed");
  }
},
async VERIFY_TWOFA_LOGIN({ commit, state }, payload) {
    try {
      const otp = payload?.otp;
      const two_fa_token =
        payload?.two_fa_token || state.twoFaLogin.two_fa_token;

      const response = await HTTP().post(
        AUTHENTICATION__API.VERIFY_TWOFA_LOGIN,
        {
          otp,
          two_fa_token,
        }
      );

      const { data } = response;

      if (response.status === 200 && data?.type === "success") {
        commit(AUTHENTICATION__MUTATIONS.TOKEN, data);
        commit(AUTHENTICATION__MUTATIONS.RESET_LOGIN_INFO);
        commit("CLEAR_TWOFA_LOGIN");

        toast.success(data.message || "Login success");
        router.push("/dashboard");

        if (state.logOutTime > 0) {
          startTrackingInactivity(this);
        }

        return true;
      }

      toast.error(data?.message || "OTP failed");
      return false;
    } catch (error) {
      toast.error(error?.response?.data?.message || "OTP verification failed");
      return false;
    }
  },

  async [AUTHENTICATION__ACTIONS.RESET]({ commit, state }) {
    try {
      const response = await HTTP().post(AUTHENTICATION__API.AUTHRESET);
      commit(AUTHENTICATION__MUTATIONS.CREATEDTIME, new Date().getTime());
      state.step = 3;
    } catch (error) {
      console.log(error)
      toast.error(error.response.data.message);
      state.step = 1
    }
  },

  async [AUTHENTICATION__ACTIONS.CODEVERIFY]({ commit, state }) {
    try {
      const code = Number(state.resetInfo.code.trim());

      const { data } = await HTTP().post(AUTHENTICATION__API.AUTHCODEVERIFY, {
        code,
      });

      if (data.type === "success") {
        state.resetInfo.isReset = true;
        state.resetInfo.code = null;
        toast.success(data.message);
        state.step = 4;
      } else {
        state.resetInfo.isReset = false;
        state.resetInfo.code = null;
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  },

  async [AUTHENTICATION__ACTIONS.PASSRESET]({ commit, state }) {
    try {
      const response = await HTTP().post(
        AUTHENTICATION__API.AUTHRESETPASSWORD,
        {
          new_password: state.resetInfo.new_password,
          confirm_password: state.resetInfo.confirm_password,
        }
      );

      if (response.status === 200) {
        toast.success(response.data.message);
        setTimeout(() => {
          window.location.reload()
        }, 300)
      }
    } catch (error) {
      console.log(error)
      toast.error(error.response.data.message);
    }
  },

  async [AUTHENTICATION__ACTIONS.VERIFYACCOUNT]({ commit, state }) {
    try {
      const { data } = await HTTP().post(
        AUTHENTICATION__API.AUTHACCOUNTVERIFY,
        {
          email: state.resetInfo.sendEmailTo,
          code: state.resetInfo.code,
        }
      );

      if (data.type === "success") {
        toast.success(data.message);
        router.push("/dashboard");
      } else if (data.type === "invalid") {
        toast.error("Too many wrong attempts. Send code again!");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  },

  async [AUTHENTICATION__ACTIONS.LOGOUT]({ state, commit }) {
    try {
      commit(AUTHENTICATION__MUTATIONS.REMOVE_TOKEN);
      Cookies.remove("partner_panel", {
        domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
        secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
        sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
      });
      Cookies.remove("client_panel", {
        domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
        secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
        sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
      });
      localStorage.removeItem('ib_status');
    } catch (error) {
      console.error(error);
    } finally {
      toast.success("You are logged out");
      router.push("/");
    }
  },


  async [AUTHENTICATION__ACTIONS.SUBMITOTP]({ state, dispatch, commit }) {
    try {
      await dispatch(AUTHENTICATION__ACTIONS.REGISTER);
    } catch (error) {
      console.error(error);
    }
  },

  async [AUTHENTICATION__ACTIONS.SENTFORGETPASSOTP]({ commit, state }, data) {
    try {
      await HTTP().post(AUTHENTICATION__API.SENTFORGETPASSOTP, {
        email: data.email,
      });
      toast.success("OTP has been sent to your email");
      state.el = 2;
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    }
  },

  async [AUTHENTICATION__ACTIONS.FORGETPASSWORDCODE]({ commit, state }, data) {
    try {
      const res = await HTTP().post(AUTHENTICATION__API.FORGETPASSWORDCODE, {
        otp: data.otp,
      });
      if (res.status === 200) {
        toast.success(res.data.message);
        state.el = 3;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  },

  async [AUTHENTICATION__ACTIONS.FORGETPASSWORDRESET](
    { commit, state },
    value
  ) {
    try {
      const { data } = await HTTP().post(
        AUTHENTICATION__API.AUTHFORGETPASSWORD,
        {
          email: value.email,
          new_password: value.new_password,
          confirm_password: value.confirm_password,
        }
      );

      if (data.type === "success") {
        toast.success(data.message);
        router.push("/");
      } else {
        toast.error(data?.message || "");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Password Reset Failed");
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
